import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FieldAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';

import BaseController from '../../BaseController';
import moment from 'moment'
import { MedicationAndDateHeaderParams } from './medication-and-date-header-params';

@Controller({ component: 'medication-and-date-header-layout', fragment: 'medication-and-date-header' })
class MedicationAndDateHeaderController extends BaseController {

  @Inject('medication-name-text')
    medicationNameTextApi!: TextAPI;

  @Inject('medication-schedule-date-text')
    medicationScheduleDateTextApi!: TextAPI;

  @Inject('medication-name-field')
    medicationNameFieldApi!: FieldAPI

  @OnMount({ target: 'medication-and-date-header-layout' })
  onMount(): void {
    const { encounterId } = this.historyService.getCurrentRouteParams();
    this.context.set({ encounterId: encounterId });
  }

  @OnMount({ target: 'medication-name-field' })
  onMountMedicationNameField(): void {
    const medicationType = MedicationAndDateHeaderParams.medicationAndDateHeaderProps?.type;
    switch (medicationType) {
      case 'INFUSION':
        this.medicationNameFieldApi.setLabel('text.solution');
        break;
      case 'RECOMMENDATIONS':
        this.medicationNameFieldApi.setLabel('label.recommendation');
        break;
      case 'GASTHERAPY':
        this.medicationNameFieldApi.setLabel('title.form.gasotherapy');
        break;
      case 'GLYCEMIC':
      case 'NURSING_INTERVENTIONS':
        this.medicationNameFieldApi.setLabel('title.form.nursing-interventations')
        break;
      default:
        this.medicationNameFieldApi.setLabel('text.item');
        break;
    }
  }

  @OnMount({ target: 'medication-name-text' })
  onMountMedicationName(): void {
    const medicationName = MedicationAndDateHeaderParams.medicationAndDateHeaderProps?.medicationName;
    this.medicationNameTextApi.setValue(String(medicationName));
  }

  @OnMount({ target: 'medication-schedule-date-text' })
  onMountMedicationScheduleDate(): void {
    const scheduleDate = MedicationAndDateHeaderParams.medicationAndDateHeaderProps?.scheduleDate;
    this.medicationScheduleDateTextApi.setValue(moment(String(scheduleDate)).format('L LTS'));
  }
}

export default MedicationAndDateHeaderController;
